import React, { useState } from 'react';
import dynamicfunction from '../../../utils/dynamicfunction';
import { RadioButton, Text } from '../../../components/SecondaryMarket';
import { fontSizes } from '../../../constants/constants';
import { formSteps } from '../../../config/config';
import ViewReverse from '../../../components/ViewReverse';
import { ReactSVG } from 'react-svg';
import icons from '../../../constants/icons';
import { useWindowWidth } from '../../../utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { cn, getContentKeyAccToLang } from '../../../utils/utils';
import { downloadAccountOpeningTerms } from '../../../store/actions/accountOpeningAction';

const SubmitApplication = ({ isTermsAgreed, setIsTermsAgreed, setStep }) => {
  const { TextWeight, isArabic } = dynamicfunction();
  const corpAOContent = useSelector((state) => state.content?.corpAOContent);
  const dispatch = useDispatch();

  const width = useWindowWidth();

  const getContentKey = (key) => {
    const content = corpAOContent;
    return getContentKeyAccToLang(content?.corporate_review_submit?.data?.attributes, key, isArabic);
  };

  // documentType: 1 = Terms and Conditions, 2 = Privacy Policy
  const handleDownloadTerms = (documentType) => {
    dispatch(downloadAccountOpeningTerms({ languageId: isArabic ? 2 : 1, documentType }));
  };

  return (
    <div>
      <Text text={getContentKey("review_submit")} weight={TextWeight.headingRegular} className={'text-dark-blue'} size={fontSizes.h30} />
      <div className='space-y-4 mt-6'>
        {formSteps.slice(0, 7).map((item) => (
          <ViewReverse key={item?.id} className={'gap-2 justify-between items-center bg-light-background py-3 md:py-4 px-3 md:px-6 rounded-lg cursor-pointer'}
            onClick={()=>setStep(item?.id)}>
            <ViewReverse className={'gap-4 items-center'}>
              <ReactSVG src={item?.filled_icon} />
              <Text text={getContentKey(item?.name)} size={width > 640 ? fontSizes.h18 : fontSizes.h14} />
            </ViewReverse>

            <ReactSVG src={icons.downArrow} className={cn(isArabic ? 'rotate-90':'-rotate-90')}/>
          </ViewReverse>
        ))}
      </div>

      <RadioButton
        label={
          <>
            {getContentKey("confirm_info")}
            <Text
              text={getContentKey("terms_conditions")}
              className={'text-dark-blue inline pe-2'}
              weight={TextWeight.bold}
              onClick={(e) => {
                e.stopPropagation();
                handleDownloadTerms(1);
              }}
            />
            {getContentKey("and")}
            <Text
              text={getContentKey("privacy_policy")}
              className={cn('text-dark-blue inline', !isArabic && 'ps-1')}
              weight={TextWeight.bold}
              onClick={(e) => {
                e.stopPropagation();
                handleDownloadTerms(2);
              }}
            />
            
          </>
        }
        selected={isTermsAgreed}
        isSquare
        onClick={() => setIsTermsAgreed(!isTermsAgreed)}
        className={'mt-10 items-start'}
      />
    </div>
  );
};

export default SubmitApplication;
